// components.application.integrations.connectIntegrationModal
import addApplication from './addApplication';

export const CONNECT_INTEGRATION_MODAL = {
  title: 'Applications',
  description: 'Please select the application that you want to connect to your account',
  help: 'Looking for an application that is not here? Put in a suggestion for our support team.',
  addApplication
};
